import React from "react";
const platformDomain = process.env.PLATFORM_DOMAIN;

const RedirectToPlatfromScript = () => {
  const redirectToPlatformIfNeeded = () => {
    return `
        var cookie = document.cookie
        var mondayActiveAccountsCookieKey = "monday_active_account_slugs=";
        var mondayActiveAccountsString = cookie.split(';').filter(function(item) {
            return item.indexOf(mondayActiveAccountsCookieKey) >= 0
        })[0];
        mondayActiveAccountsString = mondayActiveAccountsString || "[]";
        mondayActiveAccountsValueString = mondayActiveAccountsString.replace(mondayActiveAccountsCookieKey, "");
        mondayActiveAccounts = JSON.parse(decodeURIComponent(mondayActiveAccountsValueString));  
        var path = window.location.pathname.trim();;
        var normalizedPath = path.endsWith("/") ? path : path + "/";
        if((normalizedPath === "/" ||  normalizedPath === "/1/") && mondayActiveAccounts.length > 0 && mondayActiveAccounts.indexOf("monday") === -1) {
            var lastActiveSlug = mondayActiveAccounts[mondayActiveAccounts.length - 1];
            var appUrl = "//"+lastActiveSlug + ".${platformDomain}";
            window.location.replace(appUrl);
        }
    `;
  };

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: redirectToPlatformIfNeeded()
      }}
    />
  );
};

export default RedirectToPlatfromScript;
